import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const ScopeType = iotsUtils.fromList(constants.acs.scopeTypes);
